<mat-card-content
  *ngIf="loading"
  class="d-flex flex-col flex-wrap align-items-center justify-content-center"
  style="padding-bottom: 36px"
>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <p>Cargando File...</p>
</mat-card-content>

<mat-card class="cardWithShadow">
  <mat-card-content *ngIf="!loading">
    <mat-card-title>
      <h2>Detalle del file {{ this.data.file?.fileNumber }}</h2>
    </mat-card-title>

    <div class="infoFilesGrid">
      <div>
        <div class="infoFilesElementGrid">
          <b>Nombre:</b> {{ this.data.file?.fileName }}
        </div>
        <div class="infoFilesElementGrid">
          <b>Estado File:</b>
          {{ this.data.file?.fileDisplayState ? this.data.file?.fileDisplayState : '-' }}
        </div>
        <div class="infoFilesElementGrid">
          <b>Nombre Itinerario:</b> {{ this.data.file?.nombreItinerario }}
        </div>
      </div>

      <div>
        <div class="infoFilesElementGrid">
          <b>Restricciones Alimenticias:</b>
          <div *ngIf="restriccionesAlimenticias; else noRestricciones">
            <div *ngFor="let passenger of this.passengers">
              {{
                passenger?.restriccionesAlimentarias
                  ? ' - ' +
                    passenger?.firstName +
                    ' ' +
                    passenger?.lastName +
                    ': ' +
                    passenger?.restriccionesAlimentarias
                  : ''
              }}
            </div>
          </div>

          <ng-template #noRestricciones>
            No hay restricciones alimenticias
          </ng-template>
        </div>

        <div class="infoFilesElementGrid">
          <b>Observaciones:</b>
          {{
            this.data.file?.observaciones ? this.data.file?.observaciones : '-'
          }}
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-content *ngIf="!loading">
    <h2>Servicios</h2>

    <div style="justify-content: flex-start; margin-bottom: 2rem">
      <mat-form-field appearance="outline" class="buttonFilter">
        <mat-label>TIPO SERVICIO</mat-label>
        <mat-select
          [(value)]="selectTipo"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let tipo of arrayTipos" value="{{ tipo }}">{{
            tipo
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="buttonFilter">
        <mat-label>CATEGORÍA SERVICIO</mat-label>
        <mat-select
          [(value)]="selectCategoria"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let categoria of arrayCategorias"
            value="{{ categoria }}"
            >{{ categoria }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <mat-card-content
      [style.display]="
        !loading && dataSource.filteredData.length !== 0 ? 'block' : 'none'
      "
      style="padding: 36px"
    >
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="dataSource"
          class="no-wrap m-t-0 v-middle w-100"
        >
          <ng-container matColumnDef="day">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="f-w-600 f-s-15 custom-column"
            >
              Día
            </th>
            <td mat-cell class="f-s-14 custom-column" *matCellDef="let element">
              {{ element.day }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nombre">
            <th
              mat-header-cell
              class="f-w-600 f-s-15 custom-column"
              *matHeaderCellDef
            >
              Nombre
            </th>
            <td mat-cell class="f-s-14 custom-column" *matCellDef="let element">
              {{ element.nombreServicio }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha">
            <th
              mat-header-cell
              class="f-w-600 f-s-15 custom-column"
              *matHeaderCellDef
            >
              Fecha
            </th>
            <td mat-cell class="f-s-14 custom-column" *matCellDef="let element">
              {{ showDate(element.day) | date: ' dd/MM/yyyy' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tipo">
            <th
              mat-header-cell
              class="f-w-600 f-s-15 custom-column"
              *matHeaderCellDef
            >
              Tipo Servicio
            </th>
            <td mat-cell class="f-s-14 custom-column" *matCellDef="let element">
              {{ element.tipoServicio }}
            </td>
          </ng-container>

          <ng-container matColumnDef="categoria">
            <th
              mat-header-cell
              class="f-w-600 f-s-15 custom-column"
              *matHeaderCellDef
            >
              Categoría Servicio
            </th>
            <td mat-cell class="f-s-14 custom-column" *matCellDef="let element">
              {{ element.categoriaServicio }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <div [hidden]="loading">
        <mat-paginator
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card-content>

  <div
    *ngIf="!loading && dataSource?.filteredData?.length === 0"
    class="d-flex justify-content-center align-items-center"
    style="width: 100%; height: 400px; text-align: center"
  >
    Lo sentimos. No tenemos datos para esta búsqueda.
    <br />Por favor, intenta con otro término.
  </div>
</mat-card>
